import React from 'react';
import Breadcrumbs from '@/components/Breadcrumbs';
import Footer from '@/components/Footer';
import ShopifyBuyButton from '@/components/ShopifyBuyButton';

const ChalkPage = () => {
  return (
    <div className="min-h-screen bg-background">
      <div className="container mx-auto px-4 sm:px-6 lg:px-8 mt-4">
        <Breadcrumbs />
      </div>
      <div className="container mx-auto px-4 sm:px-6 lg:px-8 py-8 sm:py-12 md:py-16">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-6 sm:gap-8 items-start">
          <div className="space-y-6">
            <h1 className="text-2xl sm:text-3xl lg:text-4xl font-bold text-foreground font-orbit">
              Peveo's Liquid Chalk
            </h1>

            <div className="flex items-baseline gap-3">
              <span className="text-4xl font-bold text-primary">48 kr</span>
              <span className="text-lg text-muted-foreground">inkl. mva</span>
            </div>

            <p className="text-base sm:text-lg text-muted-foreground leading-relaxed">
              Utforsk den ultimate løsningen for bedre grep og ytelse med Peveo's Liquid Chalk. Vår unike formel er skapt med deg i tankene, med en imponerende størrelse på hele 200 ml og en revolusjonerende sammensetning som gir deg mer kalk og mindre alkohol enn andre alternativer på markedet.
            </p>
            <p className="text-base sm:text-lg text-muted-foreground leading-relaxed">
              Det som virkelig skiller vår Liquid Chalk fra resten, er den utrolig tykke konsistensen som nærmest minner om kremkalk. Denne tette konsistensen sikrer en jevn og pålitelig påføring, slik at du kan nyte et solid grep som varer gjennom hele treningsøkten.
            </p>
            <p className="text-base sm:text-lg text-muted-foreground leading-relaxed">
              Vår spesielle flaske er designet for å holde produktet friskt og brukbart uten å tette seg, selv med det lave alkoholinnholdet og det høye kalkinnholdet. Du kan stole på at Peveo's Liquid Chalk gir deg den pålitelige ytelsen du trenger, uten å måtte bekymre deg for klumper eller blokkeringer.
            </p>

            <div className="bg-muted p-6 sm:p-8 rounded-lg border border-border">
              <h3 className="text-2xl sm:text-3xl font-bold text-foreground mb-4">
                Sammenlign og se forskjellen
              </h3>
              <p className="text-base sm:text-lg text-muted-foreground leading-relaxed mb-4">
                Vi oppfordrer treningssentre til å utforske og sammenligne ulike kalkalternativer og priser på markedet. Dette vil gi dere førstehåndserfaring med kvalitetsforskjellen, og demonstrere hvorfor Peveo's Liquid Chalk er det foretrukne valget.
              </p>
              <p className="text-base sm:text-lg text-muted-foreground leading-relaxed">
                Når du velger vårt produkt, bidrar du direkte til utviklingen av innovative treningsmaskiner som vår liggende leg-extension og fremtidige prosjekter.
              </p>
            </div>

            <div className="pt-4">
              <ShopifyBuyButton
                productId="9358249001191"
                componentId="product-component-chalk"
                domain="6pjebd-jw.myshopify.com"
                storefrontAccessToken="24c563b5bb4fa1b2d3b84fcb8e32090c"
                className="w-full"
              />
            </div>
          </div>

          <div className="relative mt-6 lg:mt-0">
            <div className="lg:sticky lg:top-8">
              <img
                src="/lovable-uploads/a4400344-573f-472d-8bb6-e96b5482c516.png"
                alt="Peveo's Liquid Chalk Premium"
                className="w-full rounded-lg shadow-lg"
              />
            </div>
          </div>
        </div>
      </div>
      <Footer />
    </div>
  );
};

export default ChalkPage;
